module.exports = "<div class=\"js-datetimepicker\"></div>";